import Enum from "../../../enums/Enum";

const DirectBillingObservationFlagCodeEnum = new Enum({
    MedicalTourismUnplanned: {name: "Unplanned medical tourism"},
    MedicalTourismPlanned: {name: "Planned medical tourism"},
});

export default DirectBillingObservationFlagCodeEnum;
